import { Card, Typography } from 'antd';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { IRootStoreProps, WithoutStore, withStore } from '../../../stores';

const { Paragraph, Title } = Typography;

class Help extends Component<IRootStoreProps> {
  render(): React.ReactNode {
    return (
      <Card bordered={false} title="Помощь" style={{ marginBottom: 8, marginTop: 10 }}>
        <Title level={5}>{'Добро пожаловать на наш сайт!'}</Title>
        <Paragraph>
          Мы рады видеть вас здесь! Если у вас возникнут вопросы или понадобится помощь, наш админ всегда на связи в
          Telegram:
          <a href="https://t.me/relaxtimeadmin" target="_blank" rel="noopener noreferrer" style={{ marginLeft: 5 }}>
            @relaxtimeadmin
          </a>
        </Paragraph>
        <Paragraph>
          И наш Telegram канал:
          <a href="https://t.me/relaxtimebet" target="_blank" rel="noopener noreferrer" style={{ marginLeft: 5 }}>
            @relaxtimebet
          </a>
        </Paragraph>
      </Card>
    );
  }
}

export const HelpPage: WithoutStore = withStore(observer(Help));
